import { render, staticRenderFns } from "./chart-pietwo.vue?vue&type=template&id=49997c7a&scoped=true"
import script from "./chart-pietwo.vue?vue&type=script&lang=js"
export * from "./chart-pietwo.vue?vue&type=script&lang=js"
import style0 from "./chart-pietwo.vue?vue&type=style&index=0&id=49997c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49997c7a",
  null
  
)

export default component.exports